import api from '@/common/libs/api'
import utils from '@/common/libs/utils'
import _ from 'lodash'
import {responseResultValidate} from '@/common/libs/common.js';
import CityCodeData from '@/common/libs/CityCodeData';

export default {
  state: {
    classInfo: {},
    schoolInfo: [],
    stageRangeList: [],
    dateRangeList: [],
    intentionSchoolList: [],
    timesheetInfo: {},
    irrSelectedTimeInfo: {},
    currentOrderResult: {},
    submitForm: {
      periodTime: '',
      schoolId: '',
      groupInfo: '',
      type: '',
      bizId: ''
    },
    buyEigthtCourseInfo: {},
    areaList: [],
    schoolList: [],
    studentCityCode: '',
    cityNotCompliantDialog: ''

  },
  actions: {
    fetchDistSchoolList({commit}){
      api.apiMethod.schools.get({sign_type: 'jwt'}).then(res => {
        if (res.data.errcode === 0){
            var data = res.data.data;
            commit('setDistSchoolList', data);
        }
      })
    },
    fetchCourseInfo({commit}, params){
      api.apiMethod.courseNewSignDetail.get({
        bizId: params.bizId,
        sign_type: 'jwt'
      }).then(res => {
        if (responseResultValidate(res.data, params.toRouterQuery)) {
          if (res.data.errcode === 0){
            commit('setClassInfo', res.data.data)
            commit('setSchoolInfo', res.data.data.schoolInfo)
          }
        }
      });
    },
    /**
     * 获取课的分期信息，长期课用，当stageRangeList长度为零时，属于非分期，否则为分期
     *  stageRangeList:分期信息
     *  dateRangeList:按周课程划分课程信息
     * @method
     * @param {Object} context 上下文环境
     * @param {Object} params 参数
     * */
    fetchDateRange({commit, dispatch}, params){
      commit('isShowLoading', true);
      api.apiMethod.courseDateRange.get({bizId: params.bizId, sign_type: 'jwt'}).then(res => {
        commit('isShowLoading', false);
        if (res.data.errcode == api.CodeMap.Success) {
          commit('setDateRange', res.data.data);
        } else {
          dispatch('toast', {title: res.data.msg, show: true});
        }
      });
    },
    /**
     * 获取日历详情
     * 1、如果是不规律的短期课，跳转到不规律选择的路由
     * 2、选择第一个未被占用的时段作为默认时段
     * @method
     * @param {Object} context
     * @param {Object} params
     * */
    fetchTimeSheet({commit, dispatch}, params){
      if (params.startDate) {
        params.startDate = params.startDate.replace(/\//g, "-");
      }
      if (params.endDate) {
        params.endDate = params.endDate.replace(/\//g, "-");
      }
      if (params.stageStart) {
        params.stageStart = params.stageStart.replace(/\//g, "-");
      }
      if (params.stageEnd) {
        params.stageEnd = params.stageEnd.replace(/\//g, "-");
      }
      params.sign_type = 'jwt';
      commit('isShowLoading', true);
      api.apiMethod.courseTimesheet.get(params).then(res => {
        commit('isShowLoading', false);
        if (res.data.errcode == api.CodeMap.Success) {
          commit('setTimesheet', _.extend(res.data.data, params));
        } else {
          dispatch('toast', {title: res.data.msg, show: true});
        }
      });
    },
    submitNewSign({commit, dispatch, state}){
        var params  = {
          bizId: state.submitForm.bizId, 
          type: state.submitForm.type,
          enrollList: state.submitForm.groupInfo
        }
        commit('isShowLoading', true);
        api.apiMethod.courseNewSignSubmit.post(params, {
          headers: {
              'Content-Type': 'application/json'
          }
      }).then(res => {
        commit('isShowLoading', false);
        let city= CityCodeData.getCityByCode(utils.cookie.get('cityCode'));
        let toRouterQuery = {};
        let name = '';
        if (state.submitForm.type == 0 ) {  //type=0.预开班（8人班） 1.后置开班（1对1）
          name = 'buyEightCourseInfo';
        } else if (state.submitForm.type == 1) {
          name = 'newsign'
        }
        toRouterQuery = {
          name: name,
          params: {
            city: city.first_word
          },
          query: {
            bizId: state.submitForm.bizId,
            type: state.submitForm.type
          }
        }

        if (responseResultValidate(res.data, toRouterQuery)){  //返回结果通过校验       
          console.log('下单结果：', res.data);
          if (res.data.errcode == 10001){  //存在待支付订单，返回待支付订单信息
            commit('orderReturnResult', {
              orderSuccess: false,
              notPayOrderInfo: res.data.data.notPayOrderInfo 
            })
          } else if (res.data.errcode == 10002){ //不符合报班资格
            // commit('orderReturnResult', {
            //   orderSuccess: false
            // })
            window.location.replace(`${res.data.data.diagnoseUrl}&fromDiagnose=guanwang&from=${encodeURIComponent(window.location.href)}`)
          } else if (res.data.errcode == 10003) { //城市校验不通过
            commit('cityDifferent', {
              studentCityCode: res.data.data.studentCityCode ? res.data.data.studentCityCode: '010'
            })
          } else if (res.data.errcode != 0) { 
            dispatch('toast', {title: res.data.msg, show: true});
          } else {
            dispatch('toast', {title: res.data.msg, show: true});
            commit('orderReturnResult', {
              orderSuccess: true,
              orderInfo: res.data.data
            })
          }
        }
      });
    },
    /**
     * 获取8人班购课信息
     * type：产品类型
     * bizId: 产品id
     */
    getBuyEigthtCourseInfo({commit, dispatch}, payloade) {
      commit('isShowLoading', true);
      api.apiMethod.getBuyEigthtCourseInfo.get(payloade.params).then(res => {
        commit('isShowLoading', false);
        if (responseResultValidate(res.data, payloade.toRouterQuery)) {
          if (res.data.errcode == 0) {
            if (res.data.data.classLevelEnrollStatus == 1) {
              dispatch('toast', {title: '测评未通过，请点击购课按钮重新测评', show: true});
            } else if (res.data.data.classLevelEnrollStatus == 2) {
              dispatch('toast', {title: '测评通过，请点击购课按钮继续下单支付', show: true});
            }
            commit('setBuyEigthtCourseInfo', res.data.data);
          } else {
            dispatch('toast', {title: res.data.msg, show: true});
          }
        }
      });
    }
  },
  mutations: {
    setDistSchoolList(state, data){
      console.log('设置区域和校区信息：', data);
      state.areaList = data.districtList;
      state.schoolList = data.schoolList;
    },
    setClassInfo(state, data){
      state.classInfo = data;
    },
    setSchoolInfo(state, data){
      state.schoolInfo = data;
    },
    setDateRange(state, data){
      state.stageRangeList = data.stageRangeList;
      state.dateRangeList = data.dateRangeList;
      state.intentionSchoolList = data.intentionSchoolList;
    },
    setTimesheet(state, data){
      var stageRangeList = state.stageRangeList;
      var stageStart = data.stageStart;
      var stageEnd = data.stageEnd;
      var countBydays = 0;
      if (data.stage && stageRangeList.length > 0) {
        var currentStage = _.find(stageRangeList, {startDate: stageStart, endDate: stageEnd});
        countBydays = _.countBy(data.headers, (day) => {
          if (day.dateType == 1) {
            return 'workday'
          } else if (day.dateType == 2) {
            return 'freeday'
          }
        });
        currentStage.workdays = countBydays && countBydays.workday;
        currentStage.freedays = countBydays && countBydays.freeday;
      }
      var periodTime = "";
      for (var i = 0; i < data.periods.length; i++) {
        var period = data.periods[i];
        if (period.disabledDateGroupIds.indexOf(data.startDate) == -1 && period.disabledDateGroupIds.indexOf(data.endDate) == -1) {
          periodTime = period.time;
          break;
        }
      }
      
      state.timesheetInfo = {
        periods: data.periods,
        periodTime: periodTime,
        datesGroup: data.headers,
        selectMode: data.selectMode,
        groupLimit: data.groupLimit,
        minSelectLimit: data.minSelectLimit,
        rate: data.rate,
        canStage: data.canStage,
        cells: data.cells
      };
    },
    setSubmitForm(state, params){
      if (params.schoolId){
        state.submitForm.schoolId = params.schoolId;
      }
      if (params.periodTime){
        state.submitForm.periodTime = params.periodTime;
      }
      if (params.groupInfo){
        state.submitForm.groupInfo = params.groupInfo;
      }
      if (params.type){
        state.submitForm.type = params.type;
      }
      if (params.bizId){
        state.submitForm.bizId = params.bizId;
      }
    },
    /**
     * 更新定制课选择时间
     * @param {Object} state 
     * @param {Object} params 
     */
    updateIrrSelectedTimeInfo(state, params){
      console.log(params);
      state.irrSelectedTimeInfo = params;
    },
    /**
     * 下单返回结果
     */
    orderReturnResult(state, data){
      state.currentOrderResult = data;
    },
    /**
     * 8人班购课信息
     */
    setBuyEigthtCourseInfo(state, data){
      state.buyEigthtCourseInfo = data;
    },
    cityDifferent(state, data) {
      state.studentCityCode = data.studentCityCode;
      state.cityNotCompliantDialog = true;
    },
    changeCityNotCompliantDialog(state, data) {
      state.cityNotCompliantDialog = data;
    }
  }
}


// WEBPACK FOOTER //
// ./src/stores/modules/courseCenter/newsign.js